import { type AppLinkOptions, linkOptions, parseSearch } from '@luminovo/design-system';

const APPS = '/apps';

/** Links a declared app path via the splat route; the codec respells its query, keeping a repeated key's last. */
export function fullPageAppLink(path: string): AppLinkOptions {
    const fragmentStart = path.indexOf('#');
    const beforeFragment = fragmentStart === -1 ? path : path.slice(0, fragmentStart);
    const queryStart = beforeFragment.indexOf('?');
    const pathname = queryStart === -1 ? beforeFragment : beforeFragment.slice(0, queryStart);
    // The manifest puts every widget route under `/apps`, and the platform checks navigation paths against them.
    if (pathname !== APPS && !pathname.startsWith(`${APPS}/`)) {
        throw new Error(`Expected a full-page app path under ${APPS}, got "${path}"`);
    }
    return linkOptions({
        to: '/apps/$',
        // The router writes `_splat` unencoded, which the manifest's lowercase-dash segments allow.
        params: { _splat: pathname.slice(`${APPS}/`.length) },
        search: queryStart === -1 ? {} : parseSearch(beforeFragment.slice(queryStart)),
        hash: fragmentStart === -1 ? undefined : path.slice(fragmentStart + 1),
    });
}
